





















import { Vue, Component } from 'vue-property-decorator';
import SyPlayer from '@/components/SyPlayer.vue';

@Component({
  components: {
    SyPlayer,
  },
})
export default class GuidePage extends Vue {
  imgStep: boolean = true;

  handleClickNextStep(val: string) {
    if (val === 'video-page') {
      this.imgStep = false;
    } else if (val === 'next-page') {
      this.$router.push({
        path: 'CollegeList',
      });
    }
  }
}
